var $a61375bbb065e4f1$exports = {};
(function() {
    const task = getTaskID();
    if (task) {
        console.log(`Jira taskId: ${task}`);
        console.log(`URL: https://pixrig.atlassian.net/browse/${task}`);
        console.log('Hash commit: ', "a062d64ab1db892abcb34467d407f02aaa554245");
    }
    function getTaskID() {
        const commitMessage = undefined;
        if (commitMessage) {
            const taskID = commitMessage.match(/EN-\d+/);
            if (taskID) return taskID[0];
        }
        return null;
    }
})();


//# sourceMappingURL=storibox.bc0657eb.js.map
